app.service('EOrdersAPI', 
	[
		'$http', 
		'ENV', 
		'Session', 
	function(
		$http, 
		ENV, 
		Session
	) {
		var service = {
			isProcessing: false,

			getEOrderProviderURL: function (eOrderProvider, patientId) {
				return $http({
					method: "POST",
					url: ENV.API + `/api/e-orders/${patientId}`,
					headers: {
						Authorization: "Bearer " + Session.token,
						"X-PRACTICE-ID": `${Session.practice.id}`,
					},
					data: eOrderProvider
				});
			}
		};

		return service;
	}]
)